export class ApiEndPointsDocument {
    addFolder = 'api/ContactDocument/AddContactDocumentFolder';
    getAllFolders = 'api/ContactDocument/GetAllContactDocumentFolders';
    AddContactDocument = 'api/ContactDocument/AddContactDocument';
    UploadContactDocument = 'api/ContactDocument/UploadContactDocument';
    deleteDocument = 'api/ContactDocument/DeleteContactDocument';
    DeleteContactPlaceholder = 'api/ContactDocument/DeleteContactPlaceholder';
    getDocumentsByFolder = 'api/ContactDocument/GetDocuments';
    getContacts = 'api/Contact/GetContacts';
    addTemplate = 'api/ContactDocument/AddContactTemplate';
    renameContactDocumentFolder = 'api/ContactDocument/RenameContactDocumentFolder';
    CheckProjectName= "api/Project/CheckProjectName";
    appendTemplate= 'api/ContactDocument/AppendContactTemplate';
    getAllTemplates= 'api/DocumentTemplate/GetAllTemplates';
    getTemplateDocuments ='api/Document/GetTemplateDocuments';
    removeFolder = 'api/ContactDocument/DeleteContactDocumentFolder';
    //getAttachment = 'api/Document/GetAttachment';
    getAttachment = 'api/App/DownloadDocument';
    getNormalAndSharedContactContacts = 'api/Contact/GetContactSelectedContact';
    getNormalAndSharedContacts = 'api/Contact/GetCoreSelectedContact';
    getNormalAndSharedCompanyContacts = 'api/Company/GetCompanySelectedContact';
    getNormalAndSharedCompanys = 'api/Company/GetCoreSelectedCompany';
    getNormalAndSharedContactCompanys = 'api/Company/GetContactSelectedCompany';
    getNormalAndSharedContactCores = 'api/Contact/GetContactSelectedCore';
    getNormalAndSharedCompanyCores = 'api/Company/GetCompanySelectedCore';
    GetContactListCoreImplementation = 'api/Contact/GetContactListCoreImplementation';
    GetCompanyListCoreImplementation = 'api/Company/GetCompanyListCoreImplementation';
    getTransactinalRoles = 'api/Contact/GetTransactinalRoles';
    addUpdateCoreContact = 'api/Contact/addUpdateCoreContact';
    addUpdateContactContact = 'api/Contact/AddUpdateContactContacts';
    addUpdateContactCompany = 'api/Company/AddUpdateContactCompany';
    addUpdateCompanyContact = 'api/Company/AddUpdateContactUnderCompany';
    addUpdateCoreCompany = 'api/Company/addUpdateCoreCompany';
    addUpdateCoreContactRole = 'api/Contact/AddUpdateCoreContactRole';
    addUpdateContactContactRole = 'api/Contact/AddUpdateContactContactRole';
    addUpdateCompanyContactRole = 'api/Company/AddUpdateContactRoleUnderCompany';
    addUpdateCoreCompanyRole = 'api/Company/AddUpdateCoreCompanyRole';
    addUpdateContactCompanyRole = 'api/Company/AddUpdateContactCompanyRole';
    deleteSelectedContact = 'api/Contact/deleteSelectedContact';
    deleteSelectedContactContact = 'api/Contact/DeleteSelectedContactContact';
    deleteSelectedCompanyContact = 'api/Company/DeleteCompanySelectedContact';
    deleteSelectedCompany = 'api/Company/DeleteSelectedCompany';
    deleteContactSelectedCompany = 'api/Company/DeleteContactSelectedCompany';
    deleteSelectedRoleCompany = 'api/Company/DeleteSelectedCompany';
    deleteSelectedRoleContactCompany = 'api/Company/DeleteContactSelectedCompany';
    getDocumentsDetailsByDocumentId = 'api/ContactDocument/GetDocumentDetails';
    UpdateDocumentsDetailsByDocumentId = 'api/ContactDocument/UpdateContactDocumentDetails';
    AddContactTouch = 'api/ContactTouch/AddContactTouch';
    GetAllContactTouches='api/ContactTouch/GetAllContactTouches';
    DeleteCoreTouch = 'api/CoreTouch/DeleteCoreTouch';
    DeleteContactTouch = 'api/ContactTouch/DeleteContactTouch';
    DeleteCompanyTouch = 'api/CompanyTouch/DeleteCompanyTouch';
    getSharedAccesslRoles = 'api/ManageRole/GetAllRolesToLinkContactCompanyCore';
    GetDocumentDetails='api/ContactDocument/GetDocumentDetails';
    MakeDocumentRequired='api/ContactDocument/MakeDocumentRequired';
    ChangeDocumentStatus ='api/ContactDocument/ChangeDocumentStatus';

    AddContactDocReviewer= 'api/ContactDocument/AddContactDocReviewer';
    GetUserList ='api/ManageUser/GetUserList';
    ChangeStatusContactDocumentByReviewer='api/ContactDocument/ChangeStatusContactDocumentByReviewer';
   
    AddContactItemForPlaceholder = 'api/ContactDocument/AddContactItemToPlaceholder';
    GetAllContactDocumentPlaceholders = "api/ContactDocument/GetAllContactDocumentPlaceholders";
    getFormFolderList = 'api/FormFolder/GetFormFolder';
    getFormFolderWithFormTemplates ='api/FormFolder/GetFormFolderWithFormTemplates';
    GetParentFormFolderHierarchy ='api/FormFolder/GetParentFormFolderHierarchy';
    FileManagerItemsWithHierarchy = "api/FileManager/FileManagerItemsWithHierarchy";
    getFileManagerFolderList = "api/FileManager/GetFileManagerFolders";
    DownloadDocument = "api/ContactDocument/DownloadDocument";
    AddCreateProjectforPlaceholder = "api/ContactDocument/AddCreateProjectforPlaceholder";
    AddProjectInfoAsTemplete="api/Project/AddProjectInfoAsTemplete";
    AddEditProjectGroupRelationParticipant = 'api/Project/AddEditProjectGroupRelationParticipant';
    AddProjectEventLog = "api/Project/AddProjectEventLog";
    getFormFolderSharedWithMe = 'api/FormFolder/GetFormFolderSharedWithMe';
    getFormFolderWithFormTemplatesSharedWithMe = 'api/FormFolder/GetFormFolderWithFormTemplatesSharedWithMe';
    AddContactMultiDocument = "api/ContactDocument/AddContactMultiDocument"
    GetSharedWithMeFileManager="api/FileManager/GetSharedWithMeFileManager";
    GetSharedWithMeFileManagerWithHierarchy="api/FileManager/GetSharedWithMeFileManagerWithHierarchy";
    GetCCCHtmlFormData= "api/Project/GetCCCHtmlFormData";
    Reorderfolders= "api/ContactDocument/Reorderfolders";
    ReorderPlaceholders = "api/ContactDocument/ReorderPlaceholders";
    ReorderPlaceholdersforNewAddedPlaceholder = "api/ContactDocument/ReorderPlaceholdersforNewAddedPlaceholder";
    ReorderfoldersforNewAddedfolder = "api/ContactDocument/ReorderfoldersforNewAddedfolder";

    AddSavedURL = "api/ContactDocument/AddUrlforPlaceholder";

    sendToPaychex = 'api/Contact/SendToPaychex'; 
    sendToPCC = 'api/Contact/SendToPCC'; 
    mergePdfFiles = "api/App/MergePdfFiles";
    shareDocsOnPortal = "api/ContactDocument/ShareDocsOnPortal";
    searchCore = "api/Core/SearchCore";
    renameContactDocument = "api/ContactDocument/RenameContactDocument";
    canThisPdfOpenforModifyByBytes="api/App/CanThisPdfOpenforModifyByBytes";
}
